import { render, staticRenderFns } from "./PageNotTranslated.vue?vue&type=template&id=75e675dc"
import script from "./PageNotTranslated.vue?vue&type=script&lang=ts"
export * from "./PageNotTranslated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports